import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex gap-4" }

import { ref, onMounted, inject } from "vue";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import notification from "@/core/plugins/notification";
import {
  getPermissionTitle,
  isAvailablePermission,
} from "@/core/types/AccountPermissionTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountPermission',
  setup(__props) {

const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);
const permissions = ref<any>([]);
const isLoading = ref(false);

const updateData = async (char: string, index: number) => {
  isLoading.value = true;
  try {
    if (char === "0") {
      await AccountService.disableAccountTransferPermissionById(
        accountDetails.value.id,
        index
      );
    } else if (char === "1") {
      await AccountService.enableAccountTransferPermissionById(
        accountDetails.value.id,
        index
      );
    }
    accountDetails.value.permission = permissions.value.join("");
    notification.success();
  } catch (err) {
    notification.danger();
    console.error(err);
  }
  isLoading.value = false;
};

onMounted(() => {
  permissions.value = accountDetails.value.permission.split("");
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (char, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_el_checkbox, {
          modelValue: permissions.value[index],
          "onUpdate:modelValue": ($event: any) => ((permissions.value[index]) = $event),
          label: _unref(getPermissionTitle)(index + 1),
          "true-label": "1",
          "false-label": "0",
          size: "large",
          disable: isLoading.value,
          onChange: ($event: any) => (updateData(char, index)),
          border: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disable", "onChange"])
      ]))
    }), 128))
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})